<template>
  <div id="app">
    <router-view></router-view>
    <Footer />
  </div>
</template>

<style>
#app {
  margin-top: 1em !important;
}
h1 {
  margin-top: 0.25em;
}
.top-block {
  margin: auto;
  border-radius: 35px 35px 0px 0px;
  border-color: red;
  border-width: 1em;
  background-color: red;
  padding: 1em;
  color: white;
  max-width: 400px;
}
.bottom-block {
  margin: auto;
  margin-top: 1em;
  border-radius: 0px 0px 35px 35px;
  border-color: red;
  border-width: 15px;
  border-style: solid;
  background-color: white;
  padding: 1em;
  color: red;
  max-width: 370px;
}
</style>

<script>
import '../theme/index.css';
import Footer from './components/Footer.vue';

export default {
  name: 'app',
  components: {
    Footer,
  },
  created() {
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
